export default __webpack_public_path__ + "static/image5-10c1bf187934f92180377e47df04eed6.jpeg";